import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import FormSkeleton from "@/components/loadings/skeleton/FormSkeleton";
import type { ChildRouteContext } from "@/root";

import Dashboard from "@/modules/recognition/user/components/Dashboard";

import { fetchPeriodQueryOptions } from "../../../services";

export const Route = createFileRoute("/_panel/_recognition/recognition/")({
  component: Component,
  pendingComponent: FormSkeleton,
  beforeLoad: () =>
    ({
      crumb: [],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchPeriodQueryOptions("current")),
});

function Component() {
  const { t } = useTranslation("recognition.user");

  return (
    <Container
      title={t("Overview")}
      description={t(
        "Appreciate your colleagues and thank them for their support.",
      )}
      className="flex h-full flex-col"
    >
      <Dashboard />
    </Container>
  );
}
